import React, { useEffect, useState } from "react";
import { forwardToNewDesign } from "../../utils/forwardToNewDesign";
import { useNavigate } from "react-router-dom";
// import axios from 'axios';
import { postRequest } from "../../services/api/apiService";
import { getAuthToken } from "../../utils/auth";
import { afterPlatformConnect } from "../../utils/afterPlatformConnect";

const MetaAdsCallback = () => {
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    if (forwardToNewDesign()) return; // tunnel lancé depuis un autre client OneBotAds
    // Extract the authorization code from the query string
    const queryParams = new URLSearchParams(window.location.search);
    const code = queryParams.get("code");

    const token = getAuthToken();
    
    if (!code) {
      console.error("Authorization code not found");
      return;
    }

    try {
      // Send the authorization code to the backend
      postRequest(
        "/api/ads-auth/meta/callback",
        { code },
        { Authorization: `Bearer ${token}` }
      )
        .then((response) => {
          // Handle successful response
          if (response.success) {
            // If everything is successful, redirect to dashboard
            navigate(afterPlatformConnect());
          } else {
            // If there's an error, redirect to error page
            setError("Failed to save Meta Ads account details.");
            navigate("/error");
          }
        })
        .catch((error) => {
          setError("Error during the Meta Ads authentication process.");
          navigate("/error");
        });
    } catch (error) {
      console.error("Error fetching data:", error.message);
    }
  }, [navigate]);

  return <div>{error && <p>{error}</p>}</div>;
};

export default MetaAdsCallback;
